import { useMutation } from '@tanstack/react-query'
import { useState, type MouseEvent } from 'react'
import { api } from '~/lib/api/client'
import { useCurrentUser } from '~/lib/auth/use-current-user'
import styles from './backfill-button.module.scss'

type Props = {
  userId: string
  date: string
}

export function BackfillButton({ userId, date }: Props) {
  const { data: me } = useCurrentUser()
  const [requested, setRequested] = useState(false)
  const mutation = useMutation({
    mutationFn: () => api.postBackfillRequest(userId, date),
    onSuccess: () => setRequested(true),
  })

  // Mutations stay admin-only post-Plan 07; non-admin teammates
  // shouldn't see the affordance (the API would 401 anyway).
  if (!me?.user.is_admin) return null

  // Stop propagation so clicking the button doesn't bubble up to the cell
  // wrapper button (which would open the side panel — but missing cells
  // aren't clickable anyway, this is defensive).
  const onClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    mutation.mutate()
  }

  if (requested) {
    return (
      <span className={styles.requested} aria-live="polite">
        Requested ✓
      </span>
    )
  }

  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      disabled={mutation.isPending}
    >
      {mutation.isPending ? 'Requesting…' : 'Request backfill'}
    </button>
  )
}
